import { api, API } from './api';

const KEY = 'planted_admin_key';

export const getAdminKey = () => {
  try { localStorage.removeItem(KEY); return sessionStorage.getItem(KEY) || ''; } catch (_) { return ''; }
};
export const setAdminKey = (v) => {
  try { sessionStorage.setItem(KEY, v); } catch (_) { /* ignore */ }
};
export const clearAdminKey = () => {
  try { sessionStorage.removeItem(KEY); localStorage.removeItem(KEY); } catch (_) { /* ignore */ }
};

const authHeaders = () => ({ 'X-Admin-Key': getAdminKey() });

export const adminLogin = (key) => api.post('/admin/login', null, { headers: { 'X-Admin-Key': key } }).then((r) => r.data);

export const fetchSermons = (refresh = false) =>
  api.get('/sermons', { params: refresh ? { refresh: true } : {} }).then((r) => r.data);

export const fetchStudies = () => api.get('/studies').then((r) => r.data);

export const studyDownloadUrl = (id) => `${API}/studies/${id}/download`;

export const uploadStudy = (title, description, file, onProgress, meta = {}) => {
  const data = new FormData();
  data.append('title', title);
  data.append('description', description || '');
  data.append('series', meta.series || '');
  data.append('session', meta.series ? String(meta.session || 0) : '0');
  data.append('series_total', meta.series ? String(meta.total || 0) : '0');
  data.append('file', file);
  return api.post('/admin/studies', data, {
    headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  }).then((r) => r.data);
};

export const fetchNextSteps = () => api.get('/admin/next-steps', { headers: authHeaders() }).then((r) => r.data);

export const updateEvent = (data) => api.put('/admin/event', data, { headers: authHeaders() }).then((r) => r.data);
export const resetFlyer = () => api.delete('/admin/event/flyer', { headers: authHeaders() }).then((r) => r.data);
export const uploadFlyer = (file) => {
  const data = new FormData();
  data.append('file', file);
  return api.post('/admin/event/flyer', data, { headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' }, timeout: 120000 }).then((r) => r.data);
};

export const deleteStudy = (id) =>
  api.delete(`/admin/studies/${id}`, { headers: authHeaders() }).then((r) => r.data);
